import { Injectable } from '@angular/core'

import { StorageService } from '../../../storage.service'
import { IProductTrack } from '../ecommerce-tracking.interfaces'
import { IReservation, ICabin } from 'app/shared/models/reservation.interfaces'

@Injectable()
export class EcommerceTrackingCabinsPreparerService {

    constructor(
        private storageService: StorageService
    ) {}

    public prepareCabinsForAmendmentTracking(before: IReservation, after: IReservation){
        const cabins = this.prepareCabins(before, after)
        this.storageService.removeSbwAmendmentCabinsTracking()
        if (cabins && cabins.length > 0) {
            this.storageService.setSbwAmendmentCabinsTracking(JSON.stringify(cabins))
        }
    }

    public getPreparedCabinsForAmendmentTracking(before: IReservation, after: IReservation): IProductTrack[] {
        const cabins = this.prepareCabins(before, after)
        return cabins
    }

    private prepareCabins(before: IReservation, after: IReservation): IProductTrack[] {
        let products: IProductTrack[] = []

        after.departures.forEach(departure => {
            const isOutbound = departure.routeCode === after.routeCode
            const departureBefore = before.departures.find(x => x.departureId === departure.departureId)
            departure.cabins.forEach(cabin => {
                if(!this.cabinExists(cabin, departureBefore && departureBefore.cabins)) {
                        let price = this.getCabinPrice({ reservation: after, cabin: cabin, departureId: departure.departureId })
                        let name = cabin.description
                        let count = cabin.count
                        let d1 = isOutbound ? 'outbound' : 'return'
                        let d5 = 'added'
                        let product = this.createCabinProduct(after, cabin.id, name, price, count, d1, d5)
                        products.push(product)
            }})
        })

        before.departures.forEach(departure => {
            const isOutbound = departure.routeCode === before.routeCode
            const departureAfter = after.departures.find(x => x.departureId === departure.departureId)
            departure.cabins.forEach(cabin => {
                if(!this.cabinExists(cabin, departureAfter && departureAfter.cabins)) {
                    let price = -this.getCabinPrice({ reservation: before, cabin: cabin, departureId: departure.departureId })
                    let name = cabin.description
                    let count = cabin.count
                    let d1 = isOutbound ? 'outbound' : 'return'
                    let d5 = 'removed'
                    let product = this.createCabinProduct(before, cabin.id, name, price, count, d1, d5)
                    products.push(product)
                }
            })
        })
        return products
    }

    private cabinExists = (cabin: ICabin, cabins: ICabin[]): boolean => {
        if(!cabins || cabins.length < 1) return false
        let result: boolean =  cabins.filter(c => c.id === cabin.id).length > 0
        return result
    }

    private getCabinPrice({ reservation, cabin, departureId }: { reservation: IReservation; cabin: ICabin; departureId: string }): number {
        let price = 0
        let priceItem = reservation.priceItems.find(
            pi => pi.departureId != null &&
             pi.departureId.toLowerCase() === departureId.toLowerCase() && 
             pi.label.toLowerCase() === cabin.description.toLowerCase()) //since id is not the same for cabin/priceItem, we can only compare label/description
        price += priceItem && priceItem.price
        return price ? price : 0
     }

    private createCabinProduct(reservation: IReservation, id: string, name: string, price: number, count: number, dimension1: string, dimension5: string): IProductTrack {
        let product = <IProductTrack>{
            id: id,
            name: name,
            brand: 'SeaBook',
            category: this.getCategory(reservation),
            variant: reservation.productCode[0],
            price:  price.toFixed(2),
            quantity: count,
            dimension1: dimension1,
            dimension5: dimension5
        }
        return product
    }

    private getCategory(reservation: IReservation): string {
        if (!reservation.routeCode) { return '' }
        if (reservation.routeCode.length !== 4) { return reservation.routeCode }
        return `${reservation.routeCode}-${reservation.routeCode.substring(2)}${reservation.routeCode.substring(0, 2)}`
    }
}
